module.exports = __webpack_public_path__ + "static/media/cashier.adc88fe7.svg";